import React from "react";
import {
  IconPhone,
  IconMail,
  IconMapPin,
  IconBrandFacebook,
  IconBrandTwitter,
  IconBrandInstagram,
  IconBrandLinkedin,
} from "@tabler/icons-react";

const Footer = () => {
  return (
    <div>
      <footer className="pt-10 lg:pt-20" style={{ backgroundColor: "rgb(0, 109, 178)" }}>
        <div className="container"  data-aos="zoom-in">
          <div className="grid grid-cols-12 gap-6 border-b border-[#A393FF] pb-8 lg:pb-16 xl:justify-between m-auto mb-0 mt-0" >
            <div className="col-span-12 md:col-span-7">
              <a href="/" className="logo" style={{ marginTop: "20px" }}>
                <img
                  width="172"
                  height="47"
                  // src="/assets/images/logo1.png"
                  src="/assets/shahid.png"
                  alt="logo"
                  className="logo__img mt-0"
                />
              </a>
              <p className="mt-4 max-w-lg text-n8 mb-5" style={{ fontSize: "19px" }}>
              Cognity Info Solutions is India’s largest leader in Application and Workforce Solutions, empowering businesses to enhance productivity through our deep domain expertise and future-ready workforce through our AI driven digital platforms.
              </p>
            </div>
            <div className="col-span-12 md:col-span-5 mt-0">
              <h5 className="h5 mb-4 text-n8">Subscribe to our newsletter</h5>
              <div className="md:item-start flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:gap-6 md:flex-col md:items-start xl:flex-row xl:items-center">
                <input
                  type="text"
                  className="bg-white w-full rounded-xl border border-n4  px-[30px] py-3 text-n8 focus:border-n6 focus:outline-none mb-5"
                  placeholder="Enter your email address"
                  required
                />
                <button className="btn-white shrink-0 mb-5">
                  <i className="ti ti-send"></i>
                  <span className="inline-block" style={{ color: "rgb(0, 109, 178)" }}> Subscribe </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="container border-b border-[#A393FF] py-10 lg:py-20"   data-aos="zoom-in" >
          <div className="grid grid-cols-12 container m-auto">
            <div className="col-span-6 sm:col-span-4 md:col-span-4 xl:col-span-4 mt-0">
              <h5 className="h5 mb-5 text-n8">Quick Links</h5>
              <ul className="flex flex-col gap-2" style={{ fontSize: "18px", marginTop: "-20px" }}>
                <li>
                  <a href="/about-us" className="text-n8 duration-300 hover:text-secondary">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="/solutions" className="text-n8 duration-300 hover:text-secondary">
                    Solutions
                  </a>
                </li>
                <li>
                  <a href="/technologies" className="text-n8 duration-300 hover:text-secondary">
                    Technologies
                  </a>
                </li>
                <li>
                  <a href="/industries" className="text-n8 duration-300 hover:text-secondary">
                    Industries
                  </a>
                </li>
                <li>
                  <a href="/careers" className="text-n8 duration-300 hover:text-secondary">
                    Careers
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-span-6 sm:col-span-4 md:col-span-4 xl:col-span-4">
              <h5 className="h5 mb-5 text-n8">Our Services</h5>
              <ul className="flex flex-col gap-2" style={{ fontSize: "18px", marginTop: "-20px" }}>
                <li>
                  <a href="/industries" className="text-n8 duration-300 hover:text-secondary">
                    Industries
                  </a>
                </li>
                <li>
                  <a href="/solutions" className="text-n8 duration-300 hover:text-secondary">
                    How We Work
                  </a>
                </li>
                <li>
                  <a href="/technologies" className="text-n8 duration-300 hover:text-secondary">
                    Find Out More
                  </a>
                </li>
                <li>
                  <a href="/contact" className="text-n8 duration-300 hover:text-secondary">
                    Lets Talk Now
                  </a>
                </li>
                {/* <li>
                  <a href="/learn more" className="text-n8 duration-300 hover:text-secondary">
                    Learn More
                  </a>
                </li> */}
              </ul>
            </div>
            <div className="col-span-12 sm:col-span-6 md:col-span-4 xl:col-span-4">
              <h5 className="h5 mb-5 text-n8">Contact us</h5>
              <ul className="flex flex-col gap-3" style={{ marginTop: "-20px" }}>
                <li>
                  <div className="flex items-start gap-6">
                    <span className="flex items-center justify-center rounded-full bg-danger p-3 text-n8" style={{ width: "50px", height: "50px" }}>
                      <IconPhone size={24} />
                    </span>
                    <span className="flex flex-col">
                      <span className="block text-sm text-n8" style={{ fontSize: "16px" }}>
                        Phone
                      </span>
                      <a href="tel:(+91)00000-00000" className="text-base text-n8 hover:text-secondary">
                        (+91) 00000-00000
                      </a>
                    </span>
                  </div>
                </li>
                <li>
                  <div className="flex items-start gap-6">
                    <span className="flex items-center justify-center rounded-full bg-success p-3 text-n8" style={{ width: "50px", height: "50px" }}>
                      <IconMail size={24} />
                    </span>
                    <span className="flex flex-col">
                      <span className="block text-sm text-n8" style={{ fontSize: "16px" }}>
                        Email
                      </span>
                      <a href="mailto:hr@cognityinfo.com" className="text-n8 hover:text-secondary">
                       hr@cognityinfo.com
                      </a>
                    </span>
                  </div>
                </li>
                <li>
                  <div className="flex items-start gap-6">
                    <span className="flex items-center justify-center rounded-full bg-warning p-3 text-n8" style={{ width: "50px", height: "50px" }}>
                      <IconMapPin size={24} />
                    </span>
                    <span className="flex flex-col">
                      <span className="block text-sm text-n8" style={{ fontSize: "16px" }}>
                        Location
                      </span>
                      <span className="text-base text-n8">
                      5th Floor, Wing-A, Statesman House, Barakhamba Road, New Delhi - 110001
                      </span>
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="lg:py-5 py-3" data-aos="zoom-in">
      <div className="container">
        <div className="grid grid-cols-12 items-center gap-6 m-auto">
          <div className="col-span-12 md:col-span-6">
            <p className="text-center text-n8 md:text-start" style={{ fontSize: "18px" }}>
              Copyright {new Date().getFullYear()} {" "}
              <a href="/" className="duration-300 hover:text-secondary">
                Cognity Info Solutions
              </a>{" "}
              All Rights Reserved.
            </p>
          </div>
          <div className="col-span-12 md:col-span-6">
            <ul className="mt-2.5 flex justify-center gap-2 lg:justify-end">
              <li>
                <a
                  className="flex items-center justify-center rounded-full bg-n8 p-2 text-primary duration-300 hover:bg-secondary hover:text-n8"
                  href="#"
                >
                  <IconBrandFacebook size={20} />
                </a>
              </li>
              <li>
                <a
                  className="flex items-center justify-center rounded-full bg-n8 p-2 text-primary duration-300 hover:bg-secondary hover:text-n8"
                  href="#"
                >
                  <IconBrandTwitter size={20} />
                </a>
              </li>
              <li>
                <a
                  className="flex items-center justify-center rounded-full bg-n8 p-2 text-primary duration-300 hover:bg-secondary hover:text-n8"
                  href="#"
                >
                  <IconBrandInstagram size={20} />
                </a>
              </li>
              <li>
                <a
                  className="flex items-center justify-center rounded-full bg-n8 p-2 text-primary duration-300 hover:bg-secondary hover:text-n8"
                  href="#"
                >
                  <IconBrandLinkedin size={20} />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
      </footer>
    </div>
  );
};

export default Footer;
